import React, { useContext, useState, useEffect, useRef } from 'react'
import Layout from '../../product/components/templates/Layout'
import DropdownManage from '@/views/Dynamic/dropdown'
const Category = () => {
    return (
        <Layout>
            <div className="dashboard staticPages">
                <DropdownManage
                    name={'category'}
                    subLevel={0}
                    subField={null}
                    avatar={true}
                    level={0}
                    table={'category'}
                    tableExt={'c'}
                    ignoreVariable={true}
                />
            </div>
        </Layout>
    )
}
export default Category
